import {CreativeTemplate} from 'common/src/modules/creativeTemplates/creativeTemplates.types';
import {DPDynamicSourceType} from 'common/src/modules/dynamicParameters/dynamicParameters.enums';
import isLocationSupportedTemplate from 'common/src/modules/creativeTemplates/utils/isLocationSupportedTemplate';
import isProductSupportedTemplate from 'common/src/modules/creativeTemplates/utils/isProductSupportedTemplate';
import isWeatherSupportedTemplate from 'common/src/modules/creativeTemplates/utils/isWeatherSupportedTemplate';
import {TemplateEssentials} from 'common/src/modules/creatives/creatives.types';
import isContentSupportedTemplate from 'common/src/modules/creativeTemplates/utils/isContentSupportedTemplate';

function getTemplateSupportedSources(template: CreativeTemplate | TemplateEssentials) {
  const sources: DPDynamicSourceType[] = [];

  if (isContentSupportedTemplate(template)) sources.push(DPDynamicSourceType.Content);
  if (isProductSupportedTemplate(template.productType)) sources.push(DPDynamicSourceType.Product);
  if (isLocationSupportedTemplate(template)) sources.push(DPDynamicSourceType.Location);
  if (isWeatherSupportedTemplate(template)) sources.push(DPDynamicSourceType.Weather);

  sources.push(DPDynamicSourceType.General);
  sources.push(DPDynamicSourceType.Campaign);

  return sources;
}

export default getTemplateSupportedSources;
